const SELECT_PLAN_CHECKOUT_TRACKING_EVENTS = {
  selectPlanCheckout: {
    billingAddress: {
      addressFieldFilled: true,
      addressOptionalFieldFilled: true,
      cityFieldFilled: true,
      countryFieldFilled: true,
      exit: true,
      fieldError: true,
      googleAddressClicked: true,
      nameFieldFilled: true,
      nextClicked: true,
      phoneFieldFilled: true,
      stateFieldFilled: true,
      visited: true,
      zipFieldFilled: true,
    },
    dormant: {
      visited: true,
      chatWithSupportClicked: true,
      planDurationMonthlySelected: true,
      planDurationYearlySelected: true,
    },
    billingContactInfo: {
      emailFieldFilled: true,
      exit: true,
      fieldError: true,
      firstNameFieldFilled: true,
      lastNameFieldFilled: true,
      phoneFieldFilled: true,
    },
    businessInfo: {
      addressFieldFilled: true,
      addressOptionalFieldFilled: true,
      cityFieldFilled: true,
      countryFieldFilled: true,
      enterManualClick: true,
      fieldError: true,
      gmbClick: true,
      googleAddressClicked: true,
      nameFieldFilled: true,
      nextClicked: true,
      phoneFieldFilled: true,
      stateFieldFilled: true,
      visited: true,
      zipFieldFilled: true,
    },
    confirmDetails: {
      billingChangeClicked: true,
      completePurchaseClicked: true,
      contactChangeClicked: true,
      error: true,
      exit: true,
      paymentChangeClicked: true,
      selectPlanTypeChangeClicked: true,
      success: true,
      visited: true,
    },
    paymentConfirmation: {
      podiumRedirectClicked: true,
      visited: true,
    },
    paymentInfo: {
      cardExpirationFieldFilled: true,
      cardNumberFieldFilled: true,
      cardSecurityCodeFieldFilled: true,
      continueClicked: true,
      differentBillingAddressClicked: true,
      error: true,
      exit: true,
      fieldError: true,
      success: true,
      visited: true,
    },
    selectPlan: {
      planClicked: true,
      planDurationMonthlySelected: true,
      planDurationYearlySelected: true,
      seeAllFeaturesOpened: true,
      seeEachCardFeaturesOpened: true,
      visited: true,
    },
    selectPlanType: {
      annualClicked: true,
      exit: true,
      monthlyClicked: true,
      visited: true,
    },
  },
};

export default SELECT_PLAN_CHECKOUT_TRACKING_EVENTS;
